// CANONICAL COPY (GH #7115). src/constants/obligations/obl-incident-response-exercise.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-incident-response-exercise',
  title: 'Conduct incident response exercise',
  description:
    'Plan and execute a tabletop or simulated incident response exercise. Document lessons learned and update procedures.',
  category: 'incidents',
  scfIds: ['SCF-INC-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'manual-attestation',
      description: 'Confirm the incident response exercise was actually conducted',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
